/* eslint-disable camelcase */
import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css";

import { useUserStore } from "@/store";
import { removeToken, getToken } from "@/utils/auth";
import { getUserSetting } from "@/api/sso/profiles";
import { appRoutes } from "./routes";
import { REDIRECT_MAIN, NOT_FOUND_ROUTE, DEFAULT_LAYOUT } from "./routes/base";
import createRouteGuard from "./guard";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

let arr = [...appRoutes];
const metaFinance = [
  "meta/finance/agent-recharge-record"
];

try {
  if (getToken()) {
    const res = await getUserSetting();
    const user_info = res.data;
    useUserStore().setProfilesUserInfo(res.data);
    useUserStore().setToken();

    // 抖音竞价过滤 关键词查询1 和 关键词查询2
    const douyinV3Index = arr.findIndex(item => item.name == "douyinV3");

    if (user_info.recommend == 1) {
      arr[douyinV3Index].children = arr[douyinV3Index].children.filter(item => item.name != "douyinV3/search-price2/index");
    } else {
      arr[douyinV3Index].children = arr[douyinV3Index].children.filter(item => item.name != "douyinV3/search-price1/index");
    }
    const findIndex1 = arr[douyinV3Index].children.findIndex(item => item.name == "douyinV3/user");

    // 如果案例管理开关是关闭，过滤案例案例管理
    const adsKey = user_info.products.findIndex((item: any) => item.key == "ads");
    if (adsKey != -1 && user_info.products[adsKey].case_is_open == 0) {
      arr[douyinV3Index].children = arr[douyinV3Index].children.filter(item => item.name != "douyinV3/case/index" && item.name != "douyinV3/case/createCase" && item.name != "douyinV3/case/editCase");
    }

    // 本地推线索大盘：user-info.products 中 key === "local" 的 clue_market_is_open === 1 才保留菜单与路由
    const localProduct = user_info.products.find((item: any) => item.key == "local");
    const clueMarketOpen = localProduct && localProduct.clue_market_is_open == 1;
    if (!clueMarketOpen && douyinV3Index != -1) {
      const clueMenu = arr[douyinV3Index].children.find(item => item.name == "douyinV3/clue");
      if (clueMenu?.children) {
        clueMenu.children = clueMenu.children.filter(item => item.name != "local/clue/market");
      }
    }

      if (adsKey != -1 && ![9, 11].includes(user_info.type)) {
          arr[douyinV3Index].children = arr[douyinV3Index].children.filter(item => item.name != "douyinV3/case/createCase" && item.name != "douyinV3/case/editCase");
      }

    // 如果是二级代理
    if (user_info.level == 2) {
      // 抖音竞价过滤 二级代理 和 二代退款 和 二代充值
      if (findIndex1 != -1) {
        arr[douyinV3Index].children[findIndex1].children = arr[douyinV3Index].children[findIndex1].children.filter(item => item.name != "douyinV3/user/agent");
      }
      const findIndex2 = arr[douyinV3Index].children.findIndex(item => item.name == "douyinV3/finance");
      if (findIndex2 != -1) {
        arr[douyinV3Index].children[findIndex2].children = arr[douyinV3Index].children[findIndex2].children.filter(item => item.name != "douyinV3/finance/agent-recharge-record");
      }

      // 信息流过滤 二级代理 和 入账记录
      // const tiktokIndex = arr.findIndex(item => item.name == "tiktok");
      // const findIndex3 = arr[tiktokIndex].children.findIndex(item => item.name == "tiktok/user");
      // if (findIndex3 != -1) {
      //   arr[tiktokIndex].children[findIndex3].children = arr[tiktokIndex].children[findIndex3].children.filter(item => item.name != "tiktok/user/agent");
      // }
      // const findIndex4 = arr[tiktokIndex].children.findIndex(item => item.name == "tiktok/funds");
      // if (findIndex4 != -1) {
      //   arr[tiktokIndex].children[findIndex4].children = arr[tiktokIndex].children[findIndex4].children.filter(item => item.name != "tiktok/funds/mine-record");
      //   arr[tiktokIndex].children[findIndex4].children[0].meta.locale = "入账记录";
      // }

      // 数字人过滤 二级代理
      // const metaIndex = arr.findIndex(item => item.name == "meta");
      //
      // const findIndex5 = arr[metaIndex].children.findIndex(item => item.name == "meta/user");
      // if (findIndex5 != -1) {
      //   arr[metaIndex].children[findIndex5].children = arr[metaIndex].children[findIndex5].children.filter(item => item.name != "meta/user/agent");
      // }
      // const findIndex6 = arr[metaIndex].children?.findIndex(item => item.name == "meta/finance");
      // arr[metaIndex].children[findIndex6].children?.forEach((item: any) => {
      //   if (metaFinance.includes(item.name)) {
      //     arr[metaIndex].children[findIndex6].children = arr[metaIndex].children[findIndex6].children?.filter(i => i.name != item.name);
      //   }
      // });

      // 百家号过滤 二级代理 和 入账记录
      const bjhIndex = arr.findIndex(item => item.name == "bjh");
      const findIndex10 = arr[bjhIndex].children.findIndex(item => item.name == "bjh/user");
      if (findIndex10 != -1) {
        arr[bjhIndex].children[findIndex10].children = arr[bjhIndex].children[findIndex10].children.filter(item => item.name != "bjh/agent2s/index");
      }

      const findIndex11 = arr[bjhIndex].children.findIndex(item => item.name == "bjh/finances");
      if (findIndex11 != -1) {
        arr[bjhIndex].children[findIndex11].children = arr[bjhIndex].children[findIndex11].children.filter(item => item.name != "bjh/finances/agent2-record");
      }

      // 小红书过滤 二代管理 和 入账记录
      const xhsIndex = arr.findIndex(item => item.name == "xhs");
      const findIndex12 = arr[xhsIndex].children.findIndex(item => item.name == "xhs/user");
      if (findIndex12 != -1) {
        arr[xhsIndex].children[findIndex12].children = arr[xhsIndex].children[findIndex12].children.filter(item => item.name != "xhs/user/agent2s");
      }

      const findIndex13 = arr[xhsIndex].children.findIndex(item => item.name == "xhs/finances");
      if (findIndex13 != -1) {
        arr[xhsIndex].children[findIndex13].children = arr[xhsIndex].children[findIndex13].children.filter(item => item.name != "xhs/finance/agent-recharge-record");
      }

      // 抖音图文过滤 二代管理 和 入账记录
      const tuwenIndex = arr.findIndex(item => item.name == "tuwen");
      const findIndex14 = arr[tuwenIndex].children.findIndex(item => item.name == "tuwen/user");
      if (findIndex14 != -1) {
        arr[tuwenIndex].children[findIndex14].children = arr[tuwenIndex].children[findIndex14].children.filter(item => item.name != "tuwen/user/agent2s");
      }

      const findIndex15 = arr[tuwenIndex].children.findIndex(item => item.name == "tuwen/finances");
      if (findIndex15 != -1) {
        arr[tuwenIndex].children[findIndex15].children = arr[tuwenIndex].children[findIndex15].children.filter(item => item.name != "tuwen/finance/agent-recharge-record");
      }

      // 快手过滤二代
      // const kuaishouIndex = arr.findIndex(item => item.name == "kuaishou");
      // const findIndex16 = arr[kuaishouIndex].children.findIndex(item => item.name == "kuaishou/user/agent2s");
      // if (findIndex16 != -1) {
      //   arr[kuaishouIndex].children.splice(findIndex16, 1);
      // }

      // 用户管理 过滤 二代管理

      const findIndex9 = arr.findIndex(item => item.name == "user");

      // if(findIndex9 != -1) {
      //   arr[findIndex9].children = arr[findIndex9].children.filter(item => item.name != 'settings/agent2s')
      // }
    }

    // 如果是员工，过滤财务
    if (user_info.type == 11) {
      // 抖音竞价
      if (douyinV3Index != -1) {
        arr[douyinV3Index].children = arr[douyinV3Index].children.filter(item => item.name != "douyinV3/finance");
      }

      // 信息流
      const tiktokIndex = arr.findIndex(item => item.name == "tiktok");
      if (tiktokIndex != -1) {
        arr[tiktokIndex].children = arr[tiktokIndex].children.filter(item => item.name != "tiktok/funds");
      }

      // 数字人
      // const metaIndex = arr.findIndex(item => item.name == "meta");
      // if (metaIndex != -1) {
      //   arr[metaIndex].children = arr[metaIndex].children.filter(item => item.name != "meta/finance");
      // }

      // 百家号
      const bjhIndex = arr.findIndex(item => item.name == "bjh");
      if (bjhIndex != -1) {
        arr[bjhIndex].children = arr[bjhIndex].children.filter(item => item.name != "bjh/finances");
      }

      // 小红书
      const xhsIndex = arr.findIndex(item => item.name == "xhs");
      if (xhsIndex != -1) {
        arr[xhsIndex].children = arr[xhsIndex].children.filter(item => item.name != "xhs/finances");
      }

      // 抖音图文
      const tuwenIndex = arr.findIndex(item => item.name == "tuwen");
      if (tuwenIndex != -1) {
        arr[tuwenIndex].children = arr[tuwenIndex].children.filter(item => item.name != "tuwen/finances");
      }

      // GEO
      const geoIndex = arr.findIndex(item => item.name == "geo");
      if (geoIndex != -1) {
        arr[geoIndex].children = arr[geoIndex].children.filter(item => item.name != "geo/finances");
      }
    }

    // local 只承载线索大盘开关，不作为产品线入口
    const productKeys = user_info.products.filter((j: any) => j.key != "local");
    arr = arr.filter(item => productKeys.some((j: any) => j.key == item.meta.products));
    if (user_info.products.every((j: any) => j.key != "staff")) {
      const userIndex = arr.findIndex(item => item.name == "user");
      if (userIndex != -1) {
        arr[userIndex].children = arr[userIndex].children.filter(item => item.name != "settings/staffs");
      }
    }

    useUserStore().setDefaultRoute(arr[0]?.redirect || '/notFound');
  }
} catch (error) {
  removeToken();
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login/index.vue"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/restsPwd",
      name: "restsPwd",
      component: DEFAULT_LAYOUT,
      meta: {
        requiresAuth: false
      },
      children: [
        {
          path: "/restsPwd/index",
          name: "restsPwd/index",
          meta: {
            locale: "首页",
            requiresAuth: true,
            icon: "icon-home"
          },
          component: () => import("@/views/restsPwd/index.vue")
        }
      ]
    },
    ...arr,
    REDIRECT_MAIN,
    NOT_FOUND_ROUTE
  ],
  scrollBehavior() {
    return { top: 0 };
  }
});

createRouteGuard(router);

// 清理旧页面遗留的列表高度监听，避免路由切换后访问已卸载的 DOM。
router.afterEach(() => {
  window.onresize = null;
});

export default router;
